/**
 * Created by karora on 11/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { WebService } from '../services/web.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}
//remember to add mulitzone question
@Component({
    selector: 'fail',
    templateUrl: './fail.component.html',
    styleUrls: ['./fail.component.css'],
    providers: [WebService],
})

export class Fail implements OnInit {

    emailFormControl = new FormControl('', [
        Validators.required,
        Validators.email,
    ]);

    matcher = new MyErrorStateMatcher();

    constructor(
        private router: Router,
        private web: WebService,
    ) { }

    ngOnInit(): void {
    }

}
